import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useState } from "react";
import { TaskForm } from "./TaskForm";

const navItems = [
  { to: "/", label: "Dashboard", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
  { to: "/settings", label: "Settings", icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" },
  { to: "/admin", label: "Admin", icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" },
];

export function Sidebar() {
  const { user, isAuthenticated } = useAuth();
  const [showNewTask, setShowNewTask] = useState(false);

  return (
    <>
      <aside className="w-56 bg-dark-900 border-r border-dark-700 flex flex-col h-screen">
        <div className="p-4 border-b border-dark-700">
          <h1 className="text-lg font-bold text-white tracking-tight">VulnTask</h1>
          <p className="text-xs text-dark-400 mt-0.5">React Demo</p>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded text-sm transition-colors ${
                  isActive
                    ? "bg-blue-900/40 text-blue-300"
                    : "text-dark-300 hover:bg-dark-800 hover:text-white"
                }`
              }
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
              </svg>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3">
          <button
            onClick={() => setShowNewTask(true)}
            className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm font-medium"
          >
            + New Task
          </button>
        </div>

        {isAuthenticated && user && (
          <div className="p-3 border-t border-dark-700">
            <div className="flex items-center gap-2">
              <img
                src={user.avatar}
                alt={user.name}
                className="w-7 h-7 rounded-full bg-dark-700"
              />
              <div className="min-w-0">
                <p className="text-sm text-white truncate">{user.name}</p>
                <p className="text-xs text-dark-400 truncate">{user.email}</p>
              </div>
            </div>
          </div>
        )}
      </aside>

      {showNewTask && <TaskForm onClose={() => setShowNewTask(false)} />}
    </>
  );
}
